import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getImplantElectronicDevice } from "app/services/dashboard/electronicDeviceAnalyticService";
import { BASE_URL } from "static/constants";

export const electronicDeviceApi = createApi({
  reducerPath: "electronicDeviceApi",
  baseQuery: fetchBaseQuery({ baseUrl: BASE_URL }),
  endpoints: (builder) => ({
    getElectronicDevice: builder.query({
      queryFn: () => {
        return { data: getImplantElectronicDevice() };
      },
    }),
  }),
});

export const { useGetElectronicDeviceQuery } = electronicDeviceApi;
